// src/frontend/js/modern/shared/filter-helpers.js
import { ensurejQuery } from './ui-helpers.js';

/**
 * Apply a jQuery-compatible filter event.
 * Third-party plugins expect the element parameter to be a jQuery object
 * and they mutate the data object in place (no return value).
 * This function supports both patterns:
 *   1. In-place mutation (legacy pattern) — returns the same (mutated) reference
 *   2. Explicit return of a new object — returns the new object
 */
export function applyModuleFilter(eventName, element, data) {
	const jQuery = window.jQuery;
	if (jQuery) {
		// Pass jQuery-wrapped element for backward compatibility with third-party
		// plugins that call .attr(), .hasClass(), .closest(), .find() on it.
		const jQueryElement = ensurejQuery(element);
		const filtered = jQuery(document).triggerHandler(eventName, [jQueryElement, data]);

		// If a handler explicitly returned a new value, use it.
		if (filtered !== null && filtered !== undefined && filtered !== false) {
			return filtered;
		}

		// No explicit return — data was likely mutated in place.
		return data;
	}

	// Fallback for environments without jQuery
	const nativeEvent = new CustomEvent(eventName, {
		bubbles: true,
		cancelable: true,
		detail: { element, data },
	});
	document.dispatchEvent(nativeEvent);
	return (nativeEvent.detail?.modifiedData) || data;
}
